import React from 'react';
import { ContactCapital, MoreFAQ } from 'components/CapitalRevamp';
import styles from '../StatusFastLoan.css';

function FastLoanInfo() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.row}>
        <ContactCapital title="Ada pertanyaan? Hubungi Moka Capital" />
      </div>
      <div className={styles.row}>
        <MoreFAQ
          title="Butuh informasi lebih lanjut mengenai Fast Loan?"
          faqTitle="Baca FAQ Fast Loan"
          faqURL="http://info.mokapos.com/faq-commonwealth"
        />
      </div>
    </div>
  );
}

export default FastLoanInfo;
